export function getHwaPageReloadCount() {
    var reloadCount = sessionStorage.getItem('ReloadCount');
    if (!reloadCount || isNaN(parseInt(reloadCount))) {
        return 0;
    }
    return parseInt(reloadCount);
}
//# sourceMappingURL=getHwaPageReloadCount.js.map